var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1861_31382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98554 7.75482L3.97887 3.04016L5.26621 2.69482L9.90021 6.97482L13.4082 6.03482C13.6644 5.96622 13.9374 6.0022 14.167 6.13485C14.3967 6.2675 14.5643 6.48596 14.6329 6.74216C14.7015 6.99836 14.6655 7.27132 14.5328 7.50098C14.4002 7.73065 14.1817 7.89822 13.9255 7.96682L3.94421 10.6402L3.42687 8.70816L3.58754 8.66482L5.23221 10.2948L3.48154 10.7642C3.33798 10.8026 3.18568 10.7921 3.04883 10.7341C2.91198 10.6761 2.79842 10.5741 2.72621 10.4442L0.977539 7.29349L1.94354 7.03482L3.58754 8.66482L6.98554 7.75416V7.75482ZM2.66687 12.6668H13.3335V14.0002H2.66687V12.6668Z",
    fill: "#0071B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1861_31382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.aaa49ebce21fd9735e5ba3af33c100f7.svg";
export { ForwardRef as ReactComponent };